// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b3f1008f","477":"9ad0746a"}[chunkId] + ".chunk.js";
};